import { useLazyQuery } from '@apollo/client';
import { SEATS_PER_TICKETS } from 'store/queries';

const useSeatsByTicketsQuery = ({ onCompleted }) => {
  const [fetchSeatsByTickets, { loading, data }] = useLazyQuery(SEATS_PER_TICKETS, {
    fetchPolicy: 'network-only',
    onCompleted: (data) => onCompleted(data?.seatsPerTickets ?? [])
  });
  const handleQuery = async ({ variables: { trainNumber, departureDate, originUIC, destinationUIC } }) => {
    await fetchSeatsByTickets({
      variables: {
        trainNumber,
        departureDate,
        originUIC,
        destinationUIC
      }
    });
  };

  return [
    handleQuery,
    {
      data,
      loading
    }
  ];
};

export default useSeatsByTicketsQuery;
